import type { IModalWrapper } from '../helpers';
import ModalHeader from './Header';

const ModalWrapper = ({ children, title, handleBackLink, root, rightSheet = false, wrapperClassName, id }: IModalWrapper) => {
	const wrapperClass = rightSheet ? 'right-sheet' : wrapperClassName;
	return (
		<div
			className={wrapperClass}
			id={id}
			data-testid='modal-wrapper'
		>
			{rightSheet && (
				<ModalHeader
					title={title}
					handleBackLink={handleBackLink}
					root={root}
				/>
			)}
			{rightSheet ? <div className='right-sheet_content scrollbar'>{children}</div> : children}
		</div>
	);
};

export default ModalWrapper;
